import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { fetchDisputeTimerContract, fetchMiniDisputeTimerContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const FetchDisputeTimer = () => {

    const { account } = useWeb3React();
    const web3 = useWeb3();
    // const contract = taskManagerContract(tokenAddress, web3);

    const fetchDisputeTimerHook = useCallback(
        async (contractAddress, reward) => {
            console.log(reward, 'rewardreward');
            
            try {
                let response;
                if (reward >= 10) {
                    const contract = fetchDisputeTimerContract(contractAddress, web3);
                    response = await contract.methods.getTaskDispute().call();
                    console.log(response, "res in taskDisputedDetails");
                } else {
                    const contract = fetchMiniDisputeTimerContract(contractAddress, web3);
                    console.log(contract.methods.getTaskMiniDispute, "contract.methods.getTaskMiniDispute", contractAddress);

                    response = await contract.methods.getTaskMiniDispute().call();
                    console.log(response, "res in taskDisputedDetails");
                }
                return response;
            } catch (error) {
                console.log('dfdfdfdfdfdf', error)
                throw error;
            }
        },
        [account, web3]
    );
    return { fetchDisputeTimerHook: fetchDisputeTimerHook };
};
export default FetchDisputeTimer;